/**
 * Composable-фасад над стором уведомлений (DEV-1017): реактивный стейт + действия
 * для колокольчика и панели.
 */
import { storeToRefs } from 'pinia'
import { useNotificationsStore } from '../stores/notifications.store'

export const useNotifications = () => {
  const store = useNotificationsStore()

  const { notifications, unreadCount, total, isLoading, isPanelOpen } = storeToRefs(store)

  return {
    notifications,
    unreadCount,
    total,
    isLoading,
    isPanelOpen,

    fetchUnreadCount: store.fetchUnreadCount,
    fetchNotifications: store.fetchNotifications,
    loadMore: store.loadMore,
    markRead: store.markRead,
    markAllRead: store.markAllRead,
    togglePanel: store.togglePanel,
    closePanel: store.closePanel,
    connectStream: store.connectStream,
    disconnectStream: store.disconnectStream,
  }
}
